import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class CashierReport extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'id',
    'cash_drawer_id',
    'shift_id',
    'user_name',
    'cash_drawer_name',
    'created_at',
    'updated_at',
    'expected_starting_balance',
    'starting_balance',
    'expected_ending_balance',
    'ending_balance',
    'amount_received',
    'cash_drop',
    'open_notes',
    'close_notes_balance',
    'close_notes_cash_drop'
)(CashierReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/cashier.model.js